import Vue from 'vue'
import Router from 'vue-router'
import { getToken, removeToken } from '../config/token'
import ProgressBar from '~/components/progress-bar.vue'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  // 首页
  {
    path: '/',
    redirect: '/login'
  },
  {
    // 首页
    path: '/index',
    component: () => import('../views/index'),
    redirect: '/index/admin',
    meta: {
      authentication: true
    },
    children: [
      {
        path: 'admin',
        component: () => import('../views/index/admin')
      }
    ]
  },
  {
    // 登录
    path: '/login',
    component: () => import('../views/login')
  },
  {
    // 外部
    path: '/outer',
    component: () => import('../views/outer'),
    meta: {
      authentication: true
    },
    children: [
      {
        path: 'add',
        component: () => import('../views/outer/add-admin')
      },
      {
        path: 'edit/:id',
        component: () => import('../views/outer/edit-admin'),
        props: true
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  if (to.matched.some(record => record.meta.authentication)) {
    let token = getToken()
    if (token) {
      next()
    } else {
      removeToken()
      next('/login')
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js